import React from 'react';
import {Card as SCard} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export const Card = ({color, header, description, meta, id, model, extra}) => {
  const cardHeader = !!header ? (<SCard.Header>{header}</SCard.Header>) : null;
  const cardMeta = !!meta ? (<SCard.Meta>{meta}</SCard.Meta>) : null;
  const cardDesc = !!description ? (<SCard.Description>{description}</SCard.Description>) : null;
  const link = `/${model}/${id}`;

  return (
    <SCard fluid color={color} link as="a" href={link} target="_blank" rel="noopener noreferrer">
      <SCard.Content color={color}>
        {cardHeader}
        {cardMeta}
        {cardDesc}
      </SCard.Content>
      {extra}
    </SCard>
  );
};
